import styled from 'styled-components';
import COLORS from '../../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import DEVICES from '../../../common/styles/devices';

const LeftDiv = styled.div`
  width: 335px;
  position: relative;

  ${(props) => props.isMobile && 'text-align: center;'}

  .header {
    font-size: 28px;
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 38px;
    color: ${COLORS.black};
  }

  .sub-content {
    font-size: 16px;
    line-height: 21px;
    margin-top: 8px;
  }
`;

const RightDiv = styled.div`
  width: 331px;

  ${(props) => props.isMobile && 'padding-top: 25px;'}

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 16px;
    box-sizing: border-box;
    border-radius: 4px;
    height: 78px;
    font-size: 14px;
    margin-bottom: 15px;
    column-gap: 25px;

    .insta-number {
      font-size: 24px;
      line-height: 38px;
      font-family: ${FONT_FAMILY.hellix.bold};
      color: ${COLORS.black};
    }

    .insta-text {
      font-size: 12px;
    }
  }
`;

const Box = styled.div`
  border: 1px solid ${(props) => (props.isActive ? '#48FAFF' : '#F0F0F0')};
`;

const Container = styled.div`
  justify-content: space-evenly;
  display: flex;
  flex-wrap: wrap;
  margin: 200px auto;
  max-width: 866px;
  color: ${COLORS.black};

  ${(props) =>
    props.isMobile &&
    `flex-direction: column;
  align-items: center;
  width: 100% !important;`}

  .button-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 54px !important;
    padding: 0 !important;

    @media ${DEVICES.mobileXL} {
      width: 331px !important;
      margin-top: 24px !important;
    }
  }
`;

const Header = styled.div`
  height: 81px;
  left: 0px;
  top: 0px;

  background: ${COLORS.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);
  align-items: center;
  display: flex;
  width: 100% !important;

  .brand-logo-wrapper {
    display: flex;
    align-self: center;
    margin-left: 120px;
    a {
      display: inline-block;
    }
    .brand-logo {
      width: 160px;
      height: 40px;
    }
  }
`;

export { LeftDiv, RightDiv, Container, Box, Header };
